// @flow

export default (num: number | string) =>
  num === -1 || num === 'unlimited' ? Infinity : Number(num);
